// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-3e91398b-54f8-4406-80b5-83da63edf2a7-" + {586: "a5fb613c6f614c8c",621: "9a27a324fd6e0c27",}[chunkId] + ".js"
}